import React, { Component } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import isEmpty from 'lodash/isEmpty';
import flatten from 'lodash/flatten';
import get from 'lodash/get';
import isPlainObject from 'lodash/isPlainObject';
import { availabilityLevelEnum } from './../../constants';
import AmountBifurcation from './AmountBifurcation';
import SavingsBifurcation from './SavingsBifurcation';
import * as Helper from '../../utils/helper';
import './CartMedicineContainer.scss';
import removeIcon from '../../images/delete.svg';
import DropdownInput from '../DropdownInput';

import ItemMRPInfo from './ItemMRPInfo';
import MedTypeIcon from '@components/MedTypeIcon/MedTypeIcon';
import { AVAILABILITY_ICON_MAP } from '@components/ProductDetail/ProductCard';
import flattenAmountBifurcation from '../../utils/flattenAmountBifurcation';

const CartMedicineContainer = ({
  medicineList,
  medicineAmountBifurcation,
  extraChargesBifurcation,
  updateCart,
  onRemove,
  productIdsWithRxAvailable,
  omsEnabled = false,
  loyaltyItem,
  selectedLPVariant,
  handleLPRemove,
  onLPVariantUpdate,
  cartLoyaltyItem,
  savingsBifurcationData
}) => {
  const bifurcationData = isEmpty(medicineAmountBifurcation) ? extraChargesBifurcation : medicineAmountBifurcation;
  return (
    <div className="CartMedicineContainer">
      <div className="CartMedicineHeader">
        <div className="MedName">Name</div>
        <div className="MedAvailability">Is Available</div>
        <div className="MedPack">Qty/Pack</div>
        <div className="MedQty">Order Qty</div>
        <div className="MedPrice">Approx. Price</div>
      </div>
      <div className="CartMedicineList">
        {medicineList.map(medicine =>
          <CartMedicineListItem
            key={medicine.itemId}
            medicine={medicine}
            onUpdate={updateCart}
            onRemove={onRemove}
            isRxAvailable={productIdsWithRxAvailable.indexOf(Number(medicine.productId)) > -1 || medicine.isRxAvailable}
            omsEnabled={omsEnabled}
          />)}
      </div>
      {!isEmpty(selectedLPVariant) &&
        <div className="CartLoyaltyList">
          <CartLoyaltyItem
            key={loyaltyItem.programId}
            loyaltyItem={loyaltyItem}
            selectedLPVariant={selectedLPVariant}
            onRemove={handleLPRemove}
            onLPVariantUpdate={onLPVariantUpdate}
            cartLoyaltyItem={cartLoyaltyItem}
          />
        </div>
      }
      <div className="rhsAmountBifurcation">
        <AmountBifurcation invoice={flattenAmountBifurcation(bifurcationData)} />
        {!isEmpty(savingsBifurcationData) && <SavingsBifurcation savingsBifurcationData={savingsBifurcationData} />}
      </div>
    </div>
  );
};

CartMedicineContainer.propTypes = {
  medicineList: PropTypes.array,
  medicineAmountBifurcation: PropTypes.array,
  productIdsWithRxAvailable: PropTypes.array.isRequired,
  extraChargesBifurcation: PropTypes.array.isRequired,
  updateCart: PropTypes.func,
  onRemove: PropTypes.func,
  loyaltyItem: PropTypes.object,
  selectedLPVariant: PropTypes.object,
  handleLPRemove: PropTypes.func,
  onLPVariantUpdate: PropTypes.func,
  savingsBifurcationData: PropTypes.object,
  cartLoyaltyItem: PropTypes.object
};

CartMedicineContainer.defaultProps = {
  medicineList: [],
  medicineAmountBifurcation: [],
  updateCart: (id, quantity) => console.log('update cart called', id, quantity),
  onRemove: id => console.log('remove from cart', id),
  loyaltyItem: {},
  selectedLPVariant: {},
  handleLPRemove: () => { },
  onLPVariantUpdate: value => console.log('', value),
  savingsBifurcationData: {},
  cartLoyaltyItem: {}
};

export default CartMedicineContainer;

/**
 * @param medicine
 * @returns {*}
 * @constructor
 */
class CartMedicineListItem extends Component {

  constructor(props) {
    super(props);
    this.state = {
      quantity: this.props.medicine.quantity,
      isDeleting: false,
      isUpdating: false,
    };
  }

  componentWillReceiveProps(nextProps) {
    const { medicine: { quantity } } = nextProps;
    if ((quantity !== this.state.quantity) && !Helper.isTimerRunning) {
      this.setState({ quantity });
    }
  }

  handleDelete = () => {
    const { medicine: { itemId }, onRemove } = this.props;
    if (this.state.isDeleting) {
      return;
    }
    this.setState({ isDeleting: true });
    onRemove(itemId).then(({ status }) => {
      if (!status) {
        this.setState({ isDeleting: false });
      }
    }).catch(() => {
      this.setState({ isDeleting: false });
    });
  }

  handleItemQtyChange = ({ value }) => {
    const { medicine: { itemId, maxQuantity } } = this.props;
    value = parseInt(value);
    if (value === 0) {
      return this.handleDelete();
    }
    this.setState({ quantity: value, isUpdating: true });
    this.props.onUpdate(itemId, value).then(() => {
      this.setState({ isUpdating: false });
    });
  }

  getFlagIdForOmsEnabled = () => {
    const { medicine, isRxAvailable } = this.props;
    const flagIdsArr = [];

    if (medicine.isRxRequired) {
      if (isRxAvailable) {
        flagIdsArr.push('rxAvailable');
      } else {
        flagIdsArr.push(6);
      }
    } else {
      flagIdsArr.push(7);
    }

    if (medicine.productType == 2) {
      flagIdsArr.push(1);
    }

    if (medicine.isRefrigerated) {
      flagIdsArr.push(5);
    }

    return flagIdsArr;
  }


  getAvailabilityIcon = () => {
    const { medicine } = this.props;

    if (medicine.availabilityLevel) {
      return AVAILABILITY_ICON_MAP[medicine.availabilityLevel];
    }

    const { productTierAttributes: { type } = {} } = medicine;
    let availabilityLevel;
    switch (type) {
      case 1:
      case 2:
        availabilityLevel = availabilityLevelEnum.RED;
        break;
      case 3:
      case 4:
        availabilityLevel = availabilityLevelEnum.YELLOW;
        break;
      case 5:
        availabilityLevel = availabilityLevelEnum.GREEN;
        break;
      default:
        availabilityLevel = availabilityLevelEnum.YELLOW;
    }

    return AVAILABILITY_ICON_MAP[availabilityLevel];
  }

  getEdd = () => {
    const { medicine } = this.props;
    if (medicine.eddDetails && medicine.eddDetails.edd) {
      return medicine.eddDetails.edd.time || 'N/A';
    } else if (medicine.eddsAvailable && medicine.eddsAvailable.length > 0) {
      const lastEdd = medicine.eddsAvailable[medicine.eddsAvailable.length - 1];
      return (
        <span>
          {lastEdd.time || 'N/A'} &nbsp;
          {
            lastEdd.imageUrl && <img src={lastEdd.imageUrl} height={15} alt="edd" />
          }
        </span>
      );
    }

    return 'N/A';
  }

  render() {
    const { medicine, isRxAvailable, omsEnabled } = this.props;
    const { quantity: itemQuantity, isUpdating, isDeleting } = this.state;
    const hasWarnings = !isEmpty(medicine.warning);

    medicine.returnDays = medicine.returnDays || medicine.returnableDays || null;

    return (
      <div className={cx('CartMedicineListItem', { HasWarning: hasWarnings, 'pe-loading': isUpdating || isDeleting })}>
        {
          omsEnabled ? <div className="medTypeIconGroup">{this.getFlagIdForOmsEnabled().map(id => <MedTypeIcon key={id} flagId={id} />)}</div> : <MedTypeIcon flagId={isRxAvailable ? 'rxAvailable' : medicine.flagId} />
        }
        <div className="detailsContainer">
          <div className="MedName">{medicine.name}</div>
          <div className="MedAvailability"><img src={this.getAvailabilityIcon()} /></div>
          <div className="MedPack">{medicine.measurementUnit}</div>
          <div className="MedQty">
            <DropdownInput
              options={Helper.createItemQtyArray(medicine.maxQuantity || 20)}
              onSelect={this.handleItemQtyChange}
              onChange={({ value }) => this.setState({ quantity: value })}
              placeholder="Add"
              value={{ label: itemQuantity, value: itemQuantity }}
              className="cartMedQty"
              emptyText="Not Allowed"
              pattern={/\d/g}
            />
            <div className="MaxQtyString" >Max Qty {medicine.maxQuantity}</div>
          </div>
          <div className="MedPrice">
            <ItemMRPInfo
              discountPercent={medicine.discountPercent}
              listPriceDecimal={medicine.mrpDecimal || medicine.totalMrp}
              salePriceDecimal={medicine.salePriceDecimal || medicine.total}
              quantity={medicine.quantity}
              omsEnabled={omsEnabled}
              isCart
            />
          </div>
          <button className={`MedRemove ${this.state.isDeleting ? 'processing' : ''}`} onClick={this.handleDelete}>
            <img src={removeIcon} alt="remove" title="remove" />
          </button>
        </div>
        {medicine.substitutionInfo && (<div className="substitutionInfo">
          <img src={require('@images/substitution.svg')} />
          <span>replaced for {medicine.substitutionInfo.originalProductDetails.name}</span>
        </div>)}
        <div className="eddContainer">
          {medicine.returnDays !== null && (medicine.returnDays === 0 ? <span className="redText">Non returnable</span> : <span><b>Return within:</b> {medicine.returnDays} days post delivery</span>)}
          {!hasWarnings && <div>EDD: {this.getEdd()}</div>}
          {hasWarnings && Array.isArray(medicine.warning) && medicine.warning.map(warn => <div key={warn.text}>{warn.text}</div>)}
          {hasWarnings && isPlainObject(medicine.warning) && <div>{medicine.warning.text}</div>}
        </div>
      </div>
    );
  }
}


/**
 *
 * Loyalty product unit
 *
 */
// eslint-disable-next-line react/no-multi-comp
class CartLoyaltyItem extends Component {

  constructor(props) {
    super(props);
    this.state = {};
  }

  handleDelete = () => {
    const { onRemove } = this.props;
    onRemove();
  }

  handleVariantChange = value => {
    const { onLPVariantUpdate } = this.props;
    onLPVariantUpdate(value);
  }

  render() {
    const { loyaltyItem, selectedLPVariant, cartLoyaltyItem } = this.props;
    const flashMessage = get(cartLoyaltyItem, 'flashMessage') || '';
    const selectedVariant = loyaltyItem.variants.find(variant => variant.id === selectedLPVariant.variantId);

    return (
      <div className={cx('CartLoyaltyListItem', { HasWarning: false, 'pe-loading': false })}>
        <div className="medTypeIconGroup"> <MedTypeIcon key={'loyalty'} flagId={'loyalty'} /></div>
        <div className="detailsContainer">
          <div className="MedName"><div>Plus Membership - {selectedVariant.description} Plan</div>
          </div>
          <div className="MedAvailability" />
          <div className="MedPack" />
          <div className="LoyaltyQty">
            <DropdownInput
              options={Helper.createLoyaltyVariantsArray(loyaltyItem.variants)}
              onSelect={this.handleVariantChange}
              value={{ label: selectedVariant.description, value: selectedVariant.id }}
              className="cartLoyaltyQty"
            />
          </div>
          <div className="LoyaltyPrice">
            <ItemMRPInfo
              listPriceDecimal={String(selectedVariant.amount)}
              salePriceDecimal={String(selectedVariant.discountedAmount)}
              quantity={1}
              omsEnabled
              isGradedDiscountApplicable
              isCart
            />
          </div>
          <button className={`MedRemove ${this.state.isDeleting ? 'processing' : ''}`} onClick={this.handleDelete}>
            <img src={removeIcon} alt="remove" title="remove" />
          </button>
        </div>
        {!isEmpty(flashMessage) &&
          <div className="flashMessage">{flashMessage}</div>
        }
      </div>
    );
  }
}
